// extracted by mini-css-extract-plugin
module.exports = {"AgreementsForm":"AgreementsForm_AgreementsForm__LmKjN","center":"AgreementsForm_center__8Tvke","skip":"AgreementsForm_skip__8cjX9","checkbox":"AgreementsForm_checkbox__4jDqj"};